import { createContext, useContext } from "react";
import type { LocalizedTexts } from "@/types/layout";

export const LocalizedTextsContext = createContext<LocalizedTexts>({});

/**
 * Hook to access localized texts from context
 */
export function useLocalizedTexts(): LocalizedTexts {
  return useContext(LocalizedTextsContext);
}

/**
 * When `?debug-translations=true` is present in the URL, every dictionary
 * lookup returns its key instead of the translated value. This makes it easy
 * to spot which key drives a given piece of on-screen text. Read live from the
 * URL so it works with client-side navigation without a reload.
 */
export function isTranslationDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;
  return (
    new URLSearchParams(window.location.search).get("debug-translations") ===
    "true"
  );
}

/**
 * Get a localized text by key with a fallback value
 */
export function t(texts: LocalizedTexts, key: string, fallback = ""): string {
  if (isTranslationDebugEnabled()) return key;
  return texts[key] ?? fallback;
}
